module.exports = __webpack_public_path__ + "img/badge-wings-air.dafb4bc9.svg";